const enum WEIGHT_TYPE {
  KG = "kg",
  LB = "lb",
}

export default WEIGHT_TYPE;
